module.exports = __webpack_public_path__ + "img/intereventos.11515998.svg";